import career from './career';
import caregiver from './caregiver';
import client from './client';
import schedule from './schedule';

export default {
  career,
  caregiver,
  client,
  schedule,
};
